import React from 'react'
import { Col, Row } from 'react-grid-system'
import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const StoreInfoSkeleton = () => {
  return (
    <div className={styles.container}>
      <Skeleton width={63} height={63} style={{ marginBottom: 8 }} />
      <Skeleton width={104} height={23} style={{ marginBottom: 27 }} />
      <Skeleton width={250} height={20} style={{ marginBottom: 14 }} />
      <Row className="w-100" gutterWidth={5} style={{ marginBottom: 30 }}>
        <Col xs={5}>
          <Skeleton width={'100%'} height={96} />
        </Col>
        <Col xs={1} className="d-flex flex-center">
          <div className={styles.splitter}></div>
        </Col>
        <Col xs={6}>
          <Skeleton width={'100%'} height={96} />
        </Col>
      </Row>
      <Row className="w-100" gutterWidth={5} style={{ marginBottom: 30 }}>
        <Col xs={5}>
          <Skeleton width={'100%'} height={96} />
        </Col>
        <Col xs={1} className="d-flex flex-center">
          <div className={styles.splitter}></div>
        </Col>
        <Col xs={6}>
          <Skeleton width={'100%'} height={96} />
        </Col>
      </Row>
      <Row className="w-100" gutterWidth={5}>
        <Col xs={5}>
          <Skeleton width={'100%'} height={96} />
        </Col>
        <Col xs={1} className="d-flex flex-center">
          <div className={styles.splitter}></div>
        </Col>
        <Col xs={6}>
          <Skeleton width={'100%'} height={96} />
        </Col>
      </Row>
    </div>
  )
}

export default StoreInfoSkeleton
